import { helper } from '@ember/component/helper';

export default helper(function json(positional /*, named*/) {
  return JSON.stringify(positional);
});
